import { ResponsiveRadar } from '@nivo/radar';

const radarData = [
  { feature: 'Dashboard', 'Free User': 70, 'Pro User': 110 },
  { feature: 'API Access', 'Free User': 30, 'Pro User': 120 },
  { feature: 'Reporting', 'Free User': 40, 'Pro User': 100 },
  { feature: 'Support', 'Free User': 50, 'Pro User': 90 },
  { feature: 'Automation', 'Free User': 20, 'Pro User': 115 },
];

export const FeatureRadarChart = () => (
    <div style={{ height: '350px' }}>
        <ResponsiveRadar
            blendMode="multiply"
            borderColor={{ from: 'color' }}
            borderWidth={2}
            colors={{ scheme: 'set1' }}
            curve="linearClosed"
            data={radarData}
            dotBorderColor={{ from: 'color' }}
            dotBorderWidth={2}
            dotColor={{ theme: 'background' }}
            dotLabel="value"
            dotLabelYOffset={-12}
            dotSize={10}
            enableDotLabel={true}
            enableDots={true}
            fillOpacity={0.25}
            gridLabelOffset={36}
            gridLevels={5}
            gridShape="circular"
            indexBy="feature"
            keys={['Free User', 'Pro User']}
            legends={[{ anchor: 'top-left', direction: 'column', translateX: -50, translateY: -40, itemWidth: 80, itemHeight: 20, symbolSize: 12, symbolShape: 'circle' }]}
            margin={{ top: 70, right: 80, bottom: 40, left: 80 }}
            maxValue="auto"
            motionConfig="wobbly"
        />
    </div>
);